import React from "react";
import { Title } from "./tree/Title";
import { MenuSearch } from "./tree/MenuSearch";
import { useSelector } from "react-redux";
import { Parent } from "./tree/Parent";
import { MenuLink } from "./tree/MenuLink";
import { Dropdown } from "react-bootstrap";
import { i18n } from "app/i18n/i18n";
import { ColWrapperMob } from "./tree/Heading";

export const MobileMenu = () => {
  const menuItems = useSelector((state) => state.menu.items);
  const lang = i18n.getLanguage();
  return menuItems[lang].map(renderMobile);
};

export const renderMobile = (item, key) => {
  if (item.col) return <ColWrapperMob key={key} {...item} />;
  else if (item.children) return <Parent key={key} {...item} />;
  else if (item.link) return <MenuLink key={key} {...item} isMobile={1} />;
  else if (item.title) return <Title key={key} {...item} />;
  else if (item.search) return <MenuSearch key={key} {...item} />;
  else if (item.separator) return <Dropdown.Divider key={key} />;
  return null;
};
